/** Add producto to cart from list */
function add_to_cart_from_list(btn) {
    btn.disabled = true;
    const handle = btn.dataset.handle;
    const payload = {
        article_id: btn.dataset.articleId,
        article_can_sell: btn.dataset.articleCanSell,
        article_api: btn.dataset.api,
        article_qty: btn.dataset.qty ?? 1
    };
    send_product_to_cart(payload).then(data => {
        if (data.status == 'success') {
            if(handle == 'update-popup') {
                btn.innerHTML = '<i class="fa fa-check me-1"></i>' + btn.dataset.text_added;
                btn.classList.remove('btn-outline-success');
                btn.classList.add('btn-success');
                updateCartSummary();
            } else {
                showCartSummary(payload.article_id);
                // window.dispatchEvent(new Event('updateCartCounter'));
            }
        } else {
            alert('Error al añadir el producto al carrito');
        }
        btn.disabled = false;
    });
}

/**
 * 
 * Añade un producto al carrito
 * 
 * @param {HTMLElement} event 
 * @returns 
 */
function article_add_to_cart(btn) {
    let transEl = document.getElementById('article-translations-container');

    let btnCartSubmit = btn;
    let handle = btnCartSubmit.dataset.handle;
    const showPopup = btnCartSubmit.hasAttribute('show-popup');

    let article_id, article_api, cart_qty, article_can_sell;

    if (handle == 'update-popup') {
        article_id = btnCartSubmit.dataset.articleId;
        article_api = btnCartSubmit.dataset.api;
        article_can_sell = btnCartSubmit.dataset.articleCanSell;
        cart_qty = btnCartSubmit.dataset.qty ?? 1;
    } else {
        let article_el = document.getElementById('article-section');
        article_id = article_el.dataset.articleId;
        article_can_sell = article_el.dataset.articleCanSell;
        article_api = article_el.dataset.articleApi;

        let cart_qty_el = document.getElementById('cart-qty');
        cart_qty = cart_qty_el.value < 0 ? 1 : cart_qty_el.value;

        if (!isInteger(cart_qty)) {
            showToast({ text: transEl.dataset.itemQtyNotValid, route: '#', type: 'error' });
            return;
        }
        cart_qty_el.disabled = true;
    }

    btnCartSubmit.disabled = true;

    send_product_to_cart({
        article_id: article_id,
        article_can_sell: article_can_sell,
        article_api: article_api,
        article_qty: cart_qty
    }).then(data => {
        if (data.status == 'success') {
            if (handle == 'update-popup') {
                btnCartSubmit.innerHTML = '<i class="fa fa-check me-1"></i>' + btnCartSubmit.dataset.text_added;
                btnCartSubmit.classList.remove('btn-outline-success');
                btnCartSubmit.classList.add('btn-success');
                updateCartSummary();
            } else {
                let cart_qty_el = document.getElementById('cart-qty');
                if (cart_qty_el) cart_qty_el.disabled = false;
                btnCartSubmit.disabled = false;
                // Handle action
                let article_el = document.getElementById('article-section');
                const article_has_related_articles = article_el.dataset.articleHasRelatedArticles;
                if(article_has_related_articles || showPopup) {
                    showCartSummary(article_id);
                } else {
                    const article_cart_url = article_el.dataset.articleCartUrl;
                    if(article_cart_url) {
                        window.location.href = article_cart_url;
                    }
                }
            }
            // window.dispatchEvent(new Event('updateCartCounter'));
        } else {
            alert('Error al añadir el producto al carrito');
            btnCartSubmit.disabled = false;
            let cart_qty_el = document.getElementById('cart-qty');
            if (cart_qty_el) cart_qty_el.disabled = false;
        }
    });

}

/**
 * Actualiza dinámicamente el resumen del carrito en el modal
 */
function updateCartSummary() {
    let token = document.querySelector('meta[name="csrf-token"]').content;
    let url = `/cart/summary/json`;

    fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'X-CSRF-TOKEN': token
        }
    })
    .then(response => response.json())
    .then(response => {
        if(response.status == 'success') {
            const data = response.data;
            
            // Actualizar contador superior
            const qtyText = document.querySelector('#modal-cart-summary .panel-title p');
            if(qtyText) qtyText.innerText = `${data.total_qty} artículos`;

            // Actualizar listado de productos
            const listContainer = document.querySelector('#modal-cart-summary .overflow-y-auto');
            if(listContainer) {
                let html = '';
                data.cart_items.forEach(item => {
                    html += `
                        <div class="mb-3 pb-2 border-bottom border-light">
                            <h6 class="mb-1 text-dark fw-bold small text-truncate d-block w-100" title="${item.name}">${item.name}</h6>
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="text-muted small">${item.quantity} x ${item.price} &euro;</span>
                                <div class="text-dark fw-bold small">
                                    ${item.total} &euro;
                                </div>
                            </div>
                        </div>
                    `;
                });
                listContainer.innerHTML = html;
            }

            // Actualizar totales
            const subtotalEl = document.querySelector('#modal-cart-summary .cart-totals-simple div:nth-child(1) span:nth-child(2)');
            if(subtotalEl) subtotalEl.innerText = `${data.price_subtotal_str} €`;

            const taxEl = document.querySelector('#modal-cart-summary .cart-totals-simple div:nth-child(2) span:nth-child(2)');
            if(taxEl) taxEl.innerText = `${data.price_tax_str} €`;

            const totalEl = document.querySelector('#modal-cart-summary .cart-totals-simple .border-top span:nth-child(2)');
            if(totalEl) totalEl.innerText = `${data.price_total_str} €`;

            updateCartInfo();
            // window.dispatchEvent(new Event('updateCartCounter'));
        }
    });
}

/**
 * Muestra un modal con el resumen del carrito y sugerencias
 * @param {int} article_id 
 */
function showCartSummary(article_id) {
    let token = document.querySelector('meta[name="csrf-token"]').content;
    let url = `/cart/summary?article_id=${article_id}`;

    fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'X-CSRF-TOKEN': token
        }
    })
    .then(response => response.text())
    .then(html => {
        let modalEl = document.getElementById('modal-cart-summary');
        if(!modalEl){
            modalEl = document.createElement('div');
            modalEl.id = 'modal-cart-summary';
            modalEl.className = 'modal fade';
            modalEl.setAttribute('tabindex', '-1');
            document.body.appendChild(modalEl);
        }
        modalEl.innerHTML = html;
        
        // Verificamos si bootstrap está disponible
        if (typeof bootstrap !== 'undefined') {
            let modal = new bootstrap.Modal(modalEl);
            modal.show();
            // Update swipper
            if(typeof Swiper !== 'undefined') {
                new Swiper('.swiperRelatedCartSummary', {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    breakpoints: {
                        640: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                        1200: { slidesPerView: 4 }
                    }
                });
            }
        } else {
            // Fallback simple si no hay bootstrap JS
            modalEl.className = 'modal fade show';
            modalEl.style.display = 'block';
            document.body.classList.add('modal-open');
        }

        updateCartInfo();
        // window.dispatchEvent(new Event('updateCartCounter'));
    });
}

function article_set_to_cart(event) {
    let transEl = document.getElementById('article-translations-container');

    let btnCartUpdate = event;
    btnCartUpdate.disabled = true;

    let article_el = btnCartUpdate;
    let article_id = article_el.dataset.articleId;
    let article_can_sell = article_el.dataset.articleCanSell;
    let article_api = article_el.dataset.articleApi;

    let cart_qty_el = document.querySelector(`#cart-qty[data-article-id="${article_id}"]`);
    let cart_qty = cart_qty_el.value < 0 ? 1 : cart_qty_el.value;

    if(!isInteger(cart_qty)) {
        showToast({text: transEl.dataset.itemQtyNotValid, route: '#', type: 'error'});
        return;
    }

    cart_qty_el.disabled = true;

    send_product_to_cart({
        article_id: article_id,
        article_can_sell: article_can_sell,
        article_api: article_api,
        article_qty: cart_qty
    }).then(data => {
        if(data.status == 'success') {
            cart_qty_el.disabled = false;
            btnCartUpdate.disabled = false;
            // showToast({text: transEl.dataset.itemSetToCart, route: '/cart'});
            location.reload();
        } else {
            alert('Error al añadir el producto al carrito');
        }
    });

}

async function send_product_to_cart({article_id, article_pvp, article_qty, article_can_sell, article_api}) {
    let token = document.querySelector('meta[name="csrf-token"]').content;

    let response = await fetch(article_api, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': token,
        },
        body: JSON.stringify({
            article_id: article_id,
            article_pvp: article_pvp,
            article_qty: parseInt(article_qty),
            json: true
        })
    });

    // GA4 Event
    let data = await response.json();
    if (window.ga4 && data.meta) {
        window.ga4.trackAddToCartEvent('add_to_cart', data.meta);
    }

    return data;
}

function showToast({text, route, type = 'success'}) {

    let typeMsg = {
        success: 'linear-gradient(90deg, #289543 0%, #289543 80%, #B6C62F 100%)',
        error: 'linear-gradient(90deg, #951010 0%, #951010 80%, #C64F2F 100%)',
        warning: 'linear-gradient(90deg, #FF0000 0%, #FF0000 80%, #FF0000 100%)',
        info: 'linear-gradient(90deg, #FF0000 0%, #FF0000 80%, #FF0000 100%)'
    };

    let bgStyleType = typeMsg[type];

    Toastify({
        text: text,
        duration: 5000,
        destination: route,
        newWindow: false,
        close: true,
        gravity: "bottom", // `top` or `bottom`
        position: "right", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
            background: bgStyleType,
        },
        onClick: function(){} // Callback after click
    }).showToast();
}

function isInteger(value) {
    return /^\d+$/.test(value);
}

function disable_all_cart_controls() {
    document.querySelectorAll('.btn-qty-change, .btn-cart-remove').forEach(btn => {
        btn.disabled = true;
        btn.style.pointerEvents = 'none';
    });
}

function enable_all_cart_controls() {
    document.querySelectorAll('.btn-qty-change, .btn-cart-remove').forEach(btn => {
        btn.disabled = false;
        btn.style.pointerEvents = 'auto';
    });
}

function article_remove_from_cart(btn) {
    if (!confirm(btn.dataset.confirmRemove)) {
        return;
    }
    let token = document.querySelector('meta[name="csrf-token"]').content;
    let article_id = btn.dataset.articleId;
    let url = btn.dataset.api || '/cart-item-remove';

    disable_all_cart_controls();

    fetch(url, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': token
        },
        body: JSON.stringify({
            article_id: article_id,
            json: 1
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status == 'success') {
            // GA4 Event
            if (window.ga4) {
                window.ga4.trackRemoveFromCart('remove_from_cart', {
                    item_id: btn.dataset.itemId,
                    item_name: btn.dataset.itemName,
                    item_category: btn.dataset.itemCategory,
                    item_price: btn.dataset.itemPrice,
                    quantity: btn.dataset.itemQuantity
                }, () => { location.reload(); });
            }
        } else {
            showToast({text: btn.dataset.errorRemove, route: '#', type: 'error'});
            enable_all_cart_controls();
        }
    })
    .catch(error => {
        console.error('Error:', error);
        showToast({text: btn.dataset.errorRemove, route: '#', type: 'error'});
        enable_all_cart_controls();
    });
}

function change_cart_qty_input(input) {
    let article_id = input.dataset.articleId;
    let qty = input.value;
    let api = input.dataset.api || '/cart-item-set';
    if (qty < 1) {
        return;
    }
    
    disable_all_cart_controls();

    send_product_to_cart({
        article_id: article_id,
        article_api: api,
        article_qty: qty,
    }).then(data => {
        if (data.status == 'success') {
            updateCartInfo();
        } else {
            showToast({text: 'Error al actualizar el carrito', route: '#', type: 'error'});
            enable_all_cart_controls();
        }
    }).catch(error => {
        console.error('Error:', error);
        showToast({text: 'Error al actualizar el carrito', route: '#', type: 'error'});
        enable_all_cart_controls();
    });
}

function updateCartInfo() {
    //location.reload(); // Prevent reload, call to event update cart counter
    setTimeout(() => {
        window.dispatchEvent(new Event('updateCartCounter'));
    }, 500);
}

// Listen updatedCartInfo event and update cart counter
window.addEventListener('updatedCartInfo', event => {
    if (event.detail.status === 'success') {
        $('#total_qty_display').text(event.detail.total_qty);
        $('#subtotal_cart_display').text(event.detail.subtotal_str);
        $('#total_cart_display').text(event.detail.total_str);
    }
    enable_all_cart_controls();
});

function change_cart_qty(btn) {
    let article_id = btn.dataset.articleId;
    let action = btn.dataset.action;
    let api = btn.dataset.api || '/cart-item-set';
    
    let qtySpan = document.getElementById('cart-qty-val-' + article_id);
    if (!qtySpan) return;
    
    let currentQty = parseInt(qtySpan.dataset.qty || qtySpan.innerText);
    if (isNaN(currentQty)) currentQty = 1;
    
    let newQty = currentQty;
    if (action === 'plus') {
        newQty = currentQty + 1;
    } else if (action === 'minus') {
        newQty = currentQty - 1;
    }
    
    if (newQty < 1) {
        return;
    }
    
    disable_all_cart_controls();
    
    send_product_to_cart({
        article_id: article_id,
        article_api: api,
        article_qty: newQty
    }).then(data => {
        if (data.status == 'success') {
            location.reload();
        } else {
            showToast({text: 'Error al actualizar el carrito', route: '#', type: 'error'});
            enable_all_cart_controls();
        }
    }).catch(error => {
        console.error('Error:', error);
        showToast({text: 'Error al actualizar el carrito', route: '#', type: 'error'});
        enable_all_cart_controls();
    });
}

window.add_to_cart_from_list = add_to_cart_from_list;
window.article_add_to_cart = article_add_to_cart;
window.article_set_to_cart = article_set_to_cart;
window.article_remove_from_cart = article_remove_from_cart;
window.change_cart_qty = change_cart_qty;
window.change_cart_qty_input = change_cart_qty_input;